import React from "react";
import { useEffect, useState } from "react";
import SvgDash from "../../Shared/Icons/bootstrap/Dash";
import SvgPlus from "../../Shared/Icons/bootstrap/Plus";

export interface INumberSelectorProps {
	inputId?: string;
	initialValue?: number;
	onValueChanged?: (value: number) => void;
	max?: number;
	min?: number;
	ariaLabel?: string;
	disabled?: boolean;
}

export const NumberSelector = (props: INumberSelectorProps) => {
	const [value, setValue] = useState<number|null>(props.initialValue ?? 0);

	const max = props.max ?? Number.MAX_SAFE_INTEGER;
	const min = props.min ?? Number.MIN_SAFE_INTEGER;
	const inputId = props.inputId ?? generateId("numberselector");

	const decrement = () => setValue(Math.max(min, value!-1));
	const increment = () => setValue(Math.min(max, value!+1));
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		//console.debug("NumberSelector.onChange", e);
		if (!isNaN(e.target.valueAsNumber)) {
			//Sätt värdet, men begränsat inom min och max
			setValue(Math.min(Math.max(e.target.valueAsNumber, min), max));

			//Om man bara får mata in en siffra släpper vi fokus direkt efter
			//lyckad inmatning -- detta bör dölja soft keyboard på mobil automatiskt
			if (max < 10)
				e.target.blur();
		}
		else if (e.target.value?.trim() == "") {
			//För att det ska funka att ta bort det gamla värdet först
			setValue(null);
		}
	};
	const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		if (isNaN(e.target.valueAsNumber))
			setValue(min > 0 ? min : 0);
	};

	useEffect(() => {
		if (value !== null && props.onValueChanged)
			props.onValueChanged(value);
	}, [value])

	return (
		<div className="input-group input-group-sm number-selector">
			<div className="input-group-prepend">
				<button disabled={props.disabled || (value ?? 0) <= min} className="btn btn-outline-dark btn-decrement" type="button" onClick={decrement}><SvgDash /></button>
			</div>
			<input id={inputId} type="number" min={props.min} max={props.max} className="form-control no-spinners"
				value={value ?? ""} onChange={onChange} onBlur={onBlur} disabled={max === 0}
				aria-label={props.ariaLabel}/>
			<div className="input-group-append">
				<button disabled={props.disabled || (value ?? 0) >= max}className="btn btn-outline-dark btn-increment" type="button" onClick={increment}><SvgPlus /></button>
			</div>
		</div>
	);
}

let currentId = 0;
export const generateId = (prefix: string = "id") => `${prefix}_${currentId++}`;